module.exports = __webpack_public_path__ + "static/img/buildsucesse.255a5259.jpg";